// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"761bb264","12":"b73f0410","80":"7f2e8c7b","327":"fe5cc283","783":"f7ebd572","985":"397b32f0","997":"96c03fd5"}[chunkId] + ".chunk.js";
};